import { createFileRoute } from "@tanstack/react-router";
import GalleryPage from "@project/user/pages/community/gallery";

export const Route = createFileRoute("/_user/_community/gallery")({
  head: () => ({ meta: [{ title: "Gallery — Jivandhara" }] }),
  component: GalleryPage,
});
